import b1 from "../assets/banner/b1.jpg"
import b2 from "../assets/banner/b2.jpg"
import b3 from "../assets/banner/b3.jpg"
import b4 from "../assets/banner/b4.jpg"
import b5 from "../assets/banner/b5.jpg"

export const bannerList = [
    {
        title: "We question everything but never doubt patterns.",
        image: b1,
        cc: "font-acumin text-black text-shadow-[0_8px_12px_#0077BE]",
    },
    {
        title: "We question everything but never doubt patterns.",
        image: b2,
        cc: "font-acumin text-black text-shadow-[0_8px_12px_#0077BE]",
    },
    {
        title: "विवेकख्यातिरविप्लवा हानोपायः।",
        image: b3,
        cc: "font-hindi text-PGreen text-shadow-[0_8px_12px_#0077BE]",
    },
    {
        title: "The uninterrupted query is necessary to absorb true knowledge. ",
        image: b4, 
        cc: "font-acumin text-black text-shadow-[0_8px_12px_#0077BE]",
    },
    {
        title: "निरंतर अभ्यास से प्राप्त​ निश्चल और निर्दोष विवेकज्ञान हान (अज्ञानता) का उपाय है।",
        image: b5,
        cc: "font-hindi text-PGreen text-shadow-[0_8px_12px_#0077BE]",
    },
]